module.exports = __webpack_public_path__ + "img/katarina_bedrooms_22.74a150f9.jpg";